module.exports = __webpack_public_path__ + "img/guide0.0312ee5b.jpg";